import { Box, type SxProps, type Theme } from "@mui/material";
import { ReactElement } from "react";

type Props = {
  animated?: boolean;
};

export function SplashLogo({ animated = true }: Props): ReactElement {
  return (
    <Box sx={logoContainerSx}>
      <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 101 107"
        sx={animated ? [logoSx, pulseSx] : logoSx}
      >
        <path d="M34.6416 0C46.3357 32.4257 63.6033 41.0153 80.5432 41.0153C92.1279 41.0153 100.325 36.9353 100.325 36.9353L100.871 37.4722L23.3849 106.618V78.0578L64.8056 42.7331C14.6416 37.2575 0.871094 0 0.871094 0H34.6416Z" />
      </Box>
    </Box>
  );
}

const logoContainerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
} satisfies SxProps<Theme>;

const logoSx = {
  width: "75px",
  height: "75px",
  fill: (theme: Theme) => theme.palette.brand.icon,
} satisfies SxProps<Theme>;

const pulseSx = {
  "@keyframes splashLogoPulse": {
    "0%": { transform: "scale3d(1, 1, 1)" },
    "50%": { transform: "scale3d(1.2, 1.2, 1.2)" },
    "100%": { transform: "scale3d(1, 1, 1)" },
  },
  animation: "splashLogoPulse 1.5s ease-in-out 1s infinite both",
} satisfies SxProps<Theme>;
